<template>
  <div class="calendar-week">
    <div class="calendar-week-header">
      <div
        v-for="(item, index) in days"
        :key="index"
        class="calendar-week-item"
        :class="{
          'active': item.isToday
        }"
      >
        <span class="calendar-week-item-weekday">
          {{ weekDays[index] }}
          <task-tags :tags="tagsList[index]" />
        </span>
        <span class="calendar-week-item-day">{{ item.cMonth + '.' + item.cDay }}</span>
      </div>
    </div>
    <all-day-task
      :tasks="allDayTasks"
      :monday="monday"
      :isMore="isAllDayMore"
      @createTask="createTask"
    />
    <div
      ref="container"
      class="calendar-week-panel"
      :class="{'normal-size': normalSize === 'normal'}"
    >
      <hours-list :isToday="isToday" />
      <current-time-line v-if="isToday" />
      <day-block
        :tasks="normalTasks"
        :isMore="isAllDayMore"
        :monday="monday"
      />
    </div>
  </div>
</template>
<script>
import solarLunar from 'solarlunar'
import calendarUtil from '@/utils/calendar'
import HoursList from './hoursList'
import CurrentTimeLine from './currentTimeLine'
import DayBlock from './dayBlock'
import AllDayTask from '../tasks/allDayTask'
import TaskTags from '@/biz-components/task-tags/index.vue'
export default {
  name: 'CalendarWeekView',
  components: {
    TaskTags,
    HoursList,
    CurrentTimeLine,
    DayBlock,
    AllDayTask
  },
  props: {
    curDate: {
      type: String,
      default: moment().format('YYYY-MM-DD')
    }
  },
  data () {
    return {
      weekDays: calendarUtil.getFullCnWeek('星期'),
      days: [],
      isToday: false,
      normalTasks: [],
      allDayTasks: [],
      tagsList: [],
      isAllDayMore: false,
      isTaskMore: false,
      monday: 0,
      normalSize: 'normal'
    }
  },
  watch: {
    curDate () {
      this.setParams()
      this.setTodayLine()
      this.normalTasks = []
      this.initDays()
    },
    '$store.state.calendar.tasks': {
      handler (newVal) {
        let loaded = this.normalTasks.length === 0
        this.filterTasks(newVal)
        loaded && this.scrollToNow()
      },
      deep: true
    }
  },
  created () {
    this.setParams()
    this.setTodayLine()
    this.initDays()
    if (this.$route.path === '/DailySchedule') {
      this.normalSize = 'long'
    }
  },
  methods: {
    setParams () {
      this.monday = moment(this.curDate, 'YYYY-MM-DD').startOf('week').valueOf()
      let rangeFrom = moment(this.monday).format('YYYY-MM-DD')
      let rangeTo = moment(this.monday).add(6, 'day').format('YYYY-MM-DD')
      this.$store.commit('updateCalendarParams', { rangeFrom, rangeTo })
    },
    setTodayLine () {
      this.isToday = moment(this.curDate, 'YYYY-MM-DD').isSame(moment(), 'week')
    },
    initDays () {
      let firstDayOfWeek = moment(this.curDate, 'YYYY-MM-DD').startOf('week')
      let day
      let days = []
      for (let i = 0; i < 7; i++, firstDayOfWeek = firstDayOfWeek.add(1, 'days')) {
        day = solarLunar.solar2lunar(firstDayOfWeek.get('year'), firstDayOfWeek.get('month') + 1, firstDayOfWeek.get('date'))
        day = day === -1 ? {
          cDay: firstDayOfWeek.get('date'),
          cMonth: firstDayOfWeek.get('month') + 1,
          cYear: firstDayOfWeek.get('year')
        } : day
        days.push(day)
      }
      this.days = days
    },
    filterTasks (tasks) {
      this.allDayTasks = []
      this.normalTasks = []
      if (!tasks.length) {
        return
      }
      tasks.map(item => {
        let sameDay = moment(item.endTime || item.dueTime).isSame(moment(item.startTime || item.dueTime), 'day')
        if (!sameDay || item.dayType === 1) {
          this.allDayTasks.push(item)
        } else {
          let weekDay = moment(item.startTime || item.dueTime).get('day')
          weekDay = weekDay === 0 ? 6 : weekDay - 1
          this.normalTasks[weekDay] = this.normalTasks[weekDay] || []
          this.normalTasks[weekDay].push(item)
        }
      })

      let tagsList = []
      this.monday = moment(this.curDate, 'YYYY-MM-DD').startOf('week').valueOf()
      let rangeFrom = moment(this.monday).format('YYYY-MM-DD')
      let rangeTo = moment(this.monday).add(6, 'day').format('YYYY-MM-DD')
      tasks.forEach(item => {
        let weekDay
        if (item.startTime) {
          let startTime = moment(rangeFrom).isBefore(item.startTime) ? item.startTime : rangeFrom
          let endTime = moment(item.endTime).isBefore(rangeTo) ? item.endTime : rangeTo
          while (!moment(startTime).isAfter(endTime, 'day')) {
            weekDay = moment(startTime).get('day')
            weekDay = weekDay === 0 ? 6 : weekDay - 1
            if (!tagsList[weekDay]) {
              tagsList[weekDay] = 0
            }
            console.log(weekDay, '??', tagsList, '---', tagsList[weekDay], '.,..', item.tags)
            tagsList[weekDay] = tagsList[weekDay] | item.tags

            startTime = moment(startTime).add(1, 'days')
          }
        } else if (item.dueTime) {
          weekDay = moment(item.dueTime).get('day')
          weekDay = weekDay === 0 ? 6 : weekDay - 1
          if (!tagsList[weekDay]) {
            tagsList[weekDay] = 0
          }
          tagsList[weekDay] = tagsList[weekDay] | item.tags
        }
      })
      this.tagsList = tagsList
      this.isAllDayMore = this.allDayTasks.length > 200
      this.isTaskMore = this.normalTasks.length > 200
    },
    scrollToNow () {
      let minScrollTop = 0
      let top = 0
      let first = true
      this.normalTasks.forEach(item => {
        let startTime = item[0].startTime || item[0].dueTime
        top = moment(startTime).diff(moment(startTime).startOf('day'), 'minutes')
        if (first) {
          minScrollTop = top
          first = false
        } else {
          minScrollTop = Math.min(top, minScrollTop)
        }
      })
      if (!top) {
        this.$refs.container.scrollTo(0, 480)
        return
      }
      this.$refs.container.scrollTo(0, minScrollTop)
    },
    createTask (params) {
      this.$store.commit('createTask', {
        dueTime: params,
        dayType: 1
      })
    }
  }
}
</script>
<style lang="stylus">
.calendar-week
  &-header
    margin-left 44px
    padding 18px 18px 12px 0
    display flex
    flex-direction row
    justify-content space-between
    align-items flex-start
    flex-wrap nowrap
  &-item
    flex 1
    text-align center
    &-weekday
      display block
      color #000
      font-size 12px
    &-day
      display block
      color #ccc
      font-size 10px
    &.active
      .calendar-week-item-weekday,
      .calendar-week-item-day
        color #ed6c00
  .calendar-week-item-weekday .task-tags
    transform: translateY(-2px)
  &-panel
    position relative
    padding-right 18px
    overflow auto
    max-height 600px
    &.normal-size
      max-height 300px
</style>
